import React from 'react';
import { Icons } from '../../constants';
import { SectionTitle } from './HomeUI';
import { motion } from 'framer-motion';

interface QuickActionProps {
    onCreateBoard: () => void;
    onImportBoard?: () => void;
    onOpenTemplateWizard: () => void;
}

export const QuickActions: React.FC<QuickActionProps> = ({
    onCreateBoard,
    onImportBoard,
    onOpenTemplateWizard
}) => {
    // "Big Tech" minimal aesthetic: Compact, horizontal, high density.
    const actionClasses = "group relative flex items-center gap-3 p-3 rounded-xl cursor-pointer transition-all duration-200 border border-slate-200/60 dark:border-white/5 bg-white dark:bg-[#121212] hover:bg-slate-50 dark:hover:bg-white/[0.02] hover:border-slate-300 dark:hover:border-white/10 active:scale-[0.99]";

    return (
        <div className="mb-8 text-left">
            <SectionTitle title="Quick Access" subtitle="" />

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">

                {/* 1. New Board (Primary) */}
                <motion.div
                    whileHover={{ y: -1 }}
                    onClick={onCreateBoard}
                    className={actionClasses}
                >
                    <div className="w-9 h-9 rounded-lg bg-blue-600 flex items-center justify-center text-white shadow-sm shadow-blue-500/20 group-hover:bg-blue-700 transition-colors shrink-0">
                        <Icons.Plus className="w-4.5 h-4.5" />
                    </div>
                    <div className="flex flex-col min-w-0">
                        <span className="text-[13px] font-semibold text-slate-900 dark:text-slate-100 truncate">New Board</span>
                        <span className="text-[11px] text-slate-500 dark:text-slate-400 truncate">Create blank canvas</span>
                    </div>
                </motion.div>

                {/* 2. Templates */}
                <motion.div
                    whileHover={{ y: -1 }}
                    onClick={onOpenTemplateWizard}
                    className={actionClasses}
                >
                    <div className="w-9 h-9 rounded-lg bg-slate-100 dark:bg-white/5 flex items-center justify-center text-slate-600 dark:text-slate-400 group-hover:bg-slate-200 dark:group-hover:bg-white/10 transition-colors shrink-0">
                        <Icons.Layout className="w-4.5 h-4.5" />
                    </div>
                    <div className="flex flex-col min-w-0">
                        <span className="text-[13px] font-semibold text-slate-900 dark:text-slate-100 truncate">Templates</span>
                        <span className="text-[11px] text-slate-500 dark:text-slate-400 truncate">Start from preset</span>
                    </div>
                </motion.div>

                {/* 3. Import */}
                <motion.div
                    whileHover={{ y: -1 }}
                    onClick={onImportBoard}
                    className={actionClasses}
                >
                    <div className="w-9 h-9 rounded-lg bg-slate-100 dark:bg-white/5 flex items-center justify-center text-slate-600 dark:text-slate-400 group-hover:bg-slate-200 dark:group-hover:bg-white/10 transition-colors shrink-0">
                        <Icons.Upload className="w-4.5 h-4.5" />
                    </div>
                    <div className="flex flex-col min-w-0">
                        <span className="text-[13px] font-semibold text-slate-900 dark:text-slate-100 truncate">Import</span>
                        <span className="text-[11px] text-slate-500 dark:text-slate-400 truncate">Upload JSON</span>
                    </div>
                </motion.div>

                {/* 4. Search (Action) */}
                <motion.div
                    whileHover={{ y: -1 }}
                    onClick={() => {
                        const searchBtn = document.getElementById('global-search-trigger');
                        searchBtn?.click();
                    }}
                    className={actionClasses}
                >
                    <div className="w-9 h-9 rounded-lg bg-slate-100 dark:bg-white/5 flex items-center justify-center text-slate-600 dark:text-slate-400 group-hover:bg-slate-200 dark:group-hover:bg-white/10 transition-colors shrink-0">
                        <Icons.Search className="w-4.5 h-4.5" />
                    </div>
                    <div className="flex flex-col min-w-0 flex-1">
                        <div className="flex items-center justify-between gap-2">
                            <span className="text-[13px] font-semibold text-slate-900 dark:text-slate-100 truncate">Search</span>
                            <kbd className="hidden sm:inline-flex items-center h-4 px-1.5 text-[9px] font-medium text-slate-500 dark:text-slate-500 bg-slate-100 dark:bg-white/5 rounded border border-slate-200 dark:border-white/5 font-mono">
                                Ctrl K
                            </kbd>
                        </div>
                        <span className="text-[11px] text-slate-500 dark:text-slate-400 truncate">Find anything</span>
                    </div>
                </motion.div>

            </div>
        </div>
    );
};
